import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format, parseISO, formatDistanceToNow } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateStr: string): string {
  return format(parseISO(dateStr), 'MMM d, yyyy')
}

export function formatDateTime(dateStr: string): string {
  return format(parseISO(dateStr), 'MMM d, yyyy HH:mm')
}

export function formatPercent(rate: number): string {
  return `${Math.round(rate * 100)}%`
}

export function formatRelativeTime(dateStr: string): string {
  return formatDistanceToNow(parseISO(dateStr), { addSuffix: true })
}

export function formatSessionStatus(status: string): string {
  switch (status) {
    case 'done': return 'Completed'
    case 'skipped': return 'Skipped'
    case 'pending': return 'Pending'
    case 'reminded': return 'Reminded'
    default: return status
  }
}

export function formatSessionSource(source: string): string {
  switch (source) {
    case 'assignment': return 'Assignment'
    case 'ai': return 'AI practice'
    case 'seed': return 'Seed'
    default: return source
  }
}
